export default __webpack_public_path__ + "static/media/icon-7.d3c737df.png";